import React from 'react';
import { cn } from '@/lib/utils';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  text: string;
  icon?: React.ElementType;
  className?: string;
}

/**
 * EmptyState — Componente oficial do Design System NetUno.
 * Uso obrigatório para estados vazios.
 * Proibido criar empty states inline fora deste componente.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  text,
  icon: Icon = Inbox,
  className,
}) => (
  <div className={cn('flex flex-col items-center justify-center gap-3 py-8 text-muted-foreground', className)}>
    <Icon className="h-8 w-8 opacity-50" strokeWidth={1.5} />
    <p className="text-sm leading-relaxed text-center">{text}</p>
  </div>
);

export default EmptyState;
